module.exports = __webpack_public_path__ + "img/decor2.a6db2be3.svg";